module.exports = __webpack_public_path__ + "img/burger_boller_done.f0e2277f.jpg";